<script setup lang="ts">
const props = defineProps<{
  name: string
  icon?: string
  side?: boolean
}>()

const icon = computed(() => String(props.icon || '').trim())
const fontIconClasses = computed(() => {
  const classNames = icon.value.split(/\s+/).filter(Boolean)
  return classNames.length && classNames.every(className => className === 'fa' || className.startsWith('fa-'))
    ? classNames
    : []
})
</script>

<template>
  <span class="nav-item-label" :class="{ 'nav-item-label-side': side }">
    <i v-if="fontIconClasses.length" :class="fontIconClasses" aria-hidden="true" />
    <span v-else-if="icon" class="nav-item-emoji" aria-hidden="true">{{ icon }}</span>
    <span class="nav-item-text">{{ name }}</span>
  </span>
</template>

<style scoped>
.nav-item-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  max-width: 100%;
  min-width: 0;
}

.nav-item-label > i,
.nav-item-emoji {
  flex: none;
  width: 1em;
  line-height: 1;
  text-align: center;
}

.nav-item-label-side {
  gap: 16px;
}

.nav-item-label-side > i,
.nav-item-label-side > .nav-item-emoji {
  width: 24px;
  font-size: 20px;
}

.nav-item-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
